import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const pricingTabs = ['Lumber', 'Plates', 'Hangers'] as const;
type PricingTab = (typeof pricingTabs)[number];

interface ViewState {
  readonly activePriceGrid: PricingTab;
}

const initialState: ViewState = {
  activePriceGrid: 'Lumber',
};

const viewSlice = createSlice({
  name: 'view',
  initialState,
  reducers: {
    setActivePriceGrid: (state, action: PayloadAction<PricingTab>) => {
      state.activePriceGrid = action.payload;
    },
  },
});

export const { setActivePriceGrid } = viewSlice.actions;
export const view = viewSlice.reducer;
